import _ from 'underscore';
import {
  IListener,
  IListeners,
  InstrumentationConfig,
  IProcessor,
  IProcessors,
  IRawLogs,
  IScenario,
} from './types';

/**
 * LogTransmitter class responsible for transmitting logs to listeners
 */
export class LogTransmitter {
  listeners: IListeners;

  processors: IProcessors;

  scenarioContext: IScenario;

  stopped: boolean;

  /**
   * @param {object} options - has listeners, optional processors and scenarioContext
   */
  constructor(options: Partial<InstrumentationConfig> = {}) {
    this.listeners = options.listeners || [];
    this.processors = options.processors || [];
    this.scenarioContext = options.scenarioContext || { id: '', value: undefined } as unknown as IScenario;
    this.stopped = false;
  }

  /**
   * Updates shared scenario context every time we write, so it can be read (as parentScenario)
   * by internal activities when writing logs
   * @param {object} rawLogs - the raw logs being transmitted to the listeners
   * @returns {undefined} - no returns
   */
  updateScenarioContext(rawLogs: IRawLogs): void {
    // Scenario is marked hidden for non user defined scenarios
    const isHiddenScenario = _.result(rawLogs.scenario!.setting, 'hidden');
    if (!isHiddenScenario) {
      this.scenarioContext.id = rawLogs.scenario!.id;
      this.scenarioContext.value = rawLogs.scenario!.value;
    }
  }

  transmit(rawLogs: IRawLogs): void {
    if (this.stopped) {
      return;
    }

    if (_.has(rawLogs, 'scenario')) {
      this.updateScenarioContext(rawLogs);
    }

    // Pass the rawLogs through each processor to enrich them
    let processedLogs = rawLogs;
    _.each(this.processors, (processor: IProcessor) => {
      processedLogs = processor.process(processedLogs);
    });

    _.each(this.listeners, (listener: IListener) => listener.write(processedLogs));
  }

  /**
   * Stop the log transmitter service by tearing down the listeners
   * @returns {undefined} - no returns
   */
  stop(): void {
    _.each(this.listeners, (listener: IListener) => {
      listener.teardown();
    });
    this.stopped = true;
  }
}
